// extracted by mini-css-extract-plugin
export default {"Form":"TextForm_Form__Sbwdm","Form__label":"TextForm_Form__label__-X4-C","Form__input":"TextForm_Form__input__zFSU3","Form__error":"TextForm_Form__error__7wrFt"};